import React from "react";
import PropTypes from "prop-types";

const PasswordResetFooter = ({ onClickOK }) => (
  <div className="password-form-footer-inner">
    <div className="password-form-footer-buttons">
      <div className="button-wrapper">
        <button
          className="footer-button footer-button-large"
          onClick={onClickOK}
        >
          OKAY
        </button>
      </div>
    </div>
  </div>
);

PasswordResetFooter.propTypes = {
  onClickOK: PropTypes.func
};

PasswordResetFooter.defaultProps = {
  onClickOK: () => {}
};

export default PasswordResetFooter;
